// Semantic intent for spinners, toasts and callouts (successor of the
// Blueprint Intent enum so call sites keep their vocabulary).
export enum Intent {
  NONE = 'none',
  PRIMARY = 'primary',
  SUCCESS = 'success',
  WARNING = 'warning',
  DANGER = 'danger',
}
